<template>
    <Widget title="Subreddits" :area="this.$props.area" :scrollable="true">
        <template v-if="hasData">
            <WidgetFilter :sections="{filter:'filter'}" slot="extras">
                <div slot="filter">
                    <Label text="Show:">
                        <el-radio v-model="show" label="comments">Comments</el-radio>
                        <el-radio v-model="show" label="karma">Karma</el-radio>
                    </Label>
                    <Label text="Sort:">
                        <el-radio v-model="sort" label="name">Name</el-radio>
                        <el-radio v-model="sort" label="value">Value</el-radio>
                    </Label>
                    <Label text="Filter:">
                        <el-input placeholder="Subreddit Filter" v-model="nameFilter"/>
                    </Label>
                </div>
            </WidgetFilter>
            <NameValue
                    v-for="(subreddit) in subreddits"
                    :key="subreddit.name"
                    :type="show"
                    :name="subreddit.name"
                    :callback="()=>open(subreddit)"
                    :value="subreddit.value"/>
        </template>
    </Widget>
</template>

<script>
    import Widget from "../Widget";
    import {mapGetters} from "vuex";
    import NameValue from "../NameValue";
    import Label from "../Label";
    import WidgetFilter from "../WidgetFilter";

    export default {
        components: {WidgetFilter, Label, NameValue, Widget},
        props: {area: String, dialog: Function},
        data() {
            return {nameFilter: '', show: 'comments', sort: 'value'}
        },
        computed: {
            ...mapGetters(['allPosts']),
            hasData() {
                return this.allPosts.length > 0;
            },
            subreddits() {
                //reduce to map
                let subs = this.allPosts.reduce((a, s) => {
                    if (a[s.data.subreddit])
                        a[s.data.subreddit].push(s);
                    else
                        a[s.data.subreddit] = [s];
                    return a;
                }, {});

                //put them in an array
                let res = Object.entries(subs).map(([k, v]) => {

                    let nv = v.length;
                    if (this.show === 'karma')
                        nv = v.reduce((a, c) => a + c.data.score, 0);

                    return {name: k, posts: v, value: nv};
                }).filter(s => s.name.toLowerCase().indexOf(this.nameFilter.toLowerCase()) >= 0)
                if (this.sort === 'value')
                    res.sort((a, b) => b.value - a.value);
                else
                    res.sort((a, b) => a.name.localeCompare(b.name));

                return res;
            }
        },
        methods: {
            open(subreddit) {
                this.dialog(subreddit.name + ' Posts', subreddit.posts)
            }
        }
    }
</script>

<style scoped>

</style>
